export const createWrapper = () => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('idx-image');

    return wrapper;
};

export const createControlsContainer = () => {
    const container = document.createElement('div');
    container.classList.add('idx-image__controls');

    return container;
};

export const createContentContainer = () => {
    const container = document.createElement('div');
    container.classList.add('idx-image__content');

    return container;
};

export const createFileInput = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.classList.add('idx-image__file-input');

    return input;
};

export const createActionButton = (label, className = '') => {
    const button = document.createElement('button');
    button.type = 'button';
    button.innerText = label;
    button.classList.add('idx-image__action-button');

    if (className) {
        button.classList.add(className);
    }

    return button;
};

const createImageExtraInfoElement = ({
    tag = 'div',
    defaultText = '',
    initialContent = '',
    classNames = [],
    allowHtml = false,
}) => {
    const element = document.createElement(tag);

    element.setAttribute('contenteditable', 'true');
    element.spellcheck = false;
    element.dataset.placeholder = defaultText;

    if (classNames.length) {
        element.classList.add(...classNames);
    }

    if (initialContent) {
        if (allowHtml) {
            element.innerHTML = initialContent;
        } else {
            element.textContent = initialContent;
        }
    }

    return element;
};

export const createCaptionElement = ({ defaultText, initialContent = '' }) =>
    createImageExtraInfoElement({
        defaultText,
        initialContent,
        allowHtml: true,
        classNames: ['cdx-input', 'idx-image__caption'],
    });

export const createLicenseElement = ({ defaultText, initialContent = '' }) =>
    createImageExtraInfoElement({
        defaultText,
        initialContent,
        allowHtml: false,
        classNames: ['cdx-input', 'idx-image__license'],
    });

export const createAltInput = ({ defaultText, initialContent = '' }) => {
    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = defaultText;
    input.value = initialContent;
    input.classList.add('cdx-input', 'idx-image__alt');

    return input;
};

export const createMetaContainer = () => {
    const meta = document.createElement('div');
    meta.classList.add('idx-image__meta');

    return meta;
};

export const createMetaField = (labelText, fieldElement) => {
    const field = document.createElement('div');
    field.classList.add('idx-image__meta-field');

    const label = document.createElement('label');
    label.classList.add('idx-image__meta-label');
    label.innerText = labelText;

    field.appendChild(label);
    field.appendChild(fieldElement);

    return field;
};

export const findOrCreateImageElement = (container) => {
    let image = container.querySelector('.idx-image__preview');

    if (!image) {
        image = document.createElement('img');
        image.classList.add('idx-image__preview');
        container.insertBefore(image, container.firstChild);
    }

    return image;
};

export const createProductSearchContainer = () => {
    const container = document.createElement('div');
    container.classList.add('idx-image__product-results');

    return container;
};

export const createProductSearchInput = (placeholder) => {
    const input = document.createElement('input');
    input.placeholder = placeholder;
    input.classList.add('cdx-input', 'idx-image__product-search-input');

    return input;
};

export const createEmptyResultElement = (message) => {
    const empty = document.createElement('div');
    empty.classList.add(
        'idx-image__product-item',
        'idx-image__product-item--empty',
    );
    empty.innerText = message;

    return empty;
};

export const createProductResultItem = (label) => {
    const item = document.createElement('div');
    item.classList.add('idx-image__product-item');
    item.innerText = label;

    return item;
};

export const removeNode = (node) => {
    if (node?.parentNode) {
        node.parentNode.removeChild(node);
    }
};

export const createProductTitleElement = ({ href, name }) => {
    const container = document.createElement('div');
    container.classList.add('idx-image__product-title');

    const link = document.createElement('a');
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer nofollow';
    link.textContent = name;
    link.classList.add('idx-image__product-title-link');

    container.appendChild(link);

    return container;
};
